import React from "react";
import { Box, Group } from "@mantine/core";

 const getColor = (gap, expected) => {
  const tolerance = 0.5; 
  if (Math.abs(gap - expected) <= tolerance) return "green";
  if (gap < expected) return "gray";
  return "red";
};

const colorMap = {
  gray: "#999", 
  green: "#16a34a", 
  red: "#dc2626", 
};

export default function PacingVariance({ actualGap, expectedGap }) {
  const colorKey = getColor(actualGap, expectedGap);
  const colorHex = colorMap[colorKey];

  if (!expectedGap || !actualGap) {
    return null; 
  }

  const width = 300;
  const height = 130;
  const padding = 20;
  const barY = 40;
  const circleR = 10;

  const maxGap = Math.max(expectedGap * 1.5, actualGap);
  const scale = (value) =>
    Math.min(
      Math.max(padding, (value / maxGap) * (width - 2 * padding) + padding),
      width - padding
    );

  let actualX = scale(actualGap);
let expectedX = scale(expectedGap);
const minGap = 45; 

if (Math.abs(actualX - expectedX) < minGap) {
  const offset = Math.sign(actualX - expectedX) || 1;
  actualX += offset * (minGap - Math.abs(actualX - expectedX));
}

  return (
    <Box style={{ textAlign: "center", width }}>
      <svg width={width} height={height} role="img" aria-label="Pacing Variance Chart">

        {/* Track Line */}
        <line
          x1={padding}
          y1={barY}
          x2={width - padding}
          y2={barY}
          stroke="#999"
          strokeWidth={8}
          strokeLinecap="round"
        />

        {/* Actual */}
        <circle
          cx={actualX}
          cy={barY}
          r={circleR}
          stroke={colorHex}
          strokeWidth={3}
          fill={colorHex === "#999" ? "#fff" : "#f0fdf4"} 
        />
        <line x1={actualX} y1={barY + circleR} x2={actualX} y2={barY + 32} stroke={colorHex} strokeWidth={2} />
        <text x={actualX} y={barY + 48} fontSize="14" fontWeight="bold" fill={colorHex} textAnchor="middle">
          {actualGap.toFixed(0)}  
        </text>
        <text x={actualX} y={barY + 64} fontSize="12" fill={colorHex} fontWeight={500} textAnchor="middle">
          Days
        </text>

        {/* Expected */}
        <circle
          cx={expectedX}
          cy={barY}
          r={circleR}
          stroke="#bbb"
          strokeDasharray="2"
          strokeWidth={3}
          fill="#fff"
        />
        <line x1={expectedX} y1={barY + circleR} x2={expectedX} y2={barY + 32} stroke="#bbb" strokeWidth={2} />
        <text x={expectedX} y={barY + 48} fontSize="14" fontWeight="bold" fill="#888" textAnchor="middle">
          {expectedGap.toFixed(0)} 
        </text>
        <text x={expectedX} y={barY + 64} fontSize="12" fill="#888" fontWeight={500} textAnchor="middle">
          Days
        </text>
      </svg>
    </Box>
  );
}
